import "./style.css";

interface PageTitleProps {
  heading: string;
  subheading: string;
  trailDuration: string;
}

const PageTitle = (props: PageTitleProps) => {
  return (
    <section className="nexis-container !pb-16 md:!pb-12 !pt-24 sm:!pt-24 px-8 sm:!px-8">
      <div className="page-title-container block md:flex md:items-center md:justify-center">
        <h1
          className="page-title-heading font-lato"
          dangerouslySetInnerHTML={{ __html: props.heading }}
        ></h1>
        <h2
          className="page-title-subheading font-lato text-center"
          dangerouslySetInnerHTML={{ __html: props.subheading.replace("%", props.trailDuration) }}
        ></h2>
      </div>
    </section>
  );
};

export default PageTitle;
